import React, { useEffect, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import { Button, Select } from "antd";
import { useManageContentStore } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";

function ManageContentLinkModal({ modalShow, setModalShow, contentKey }) {
  const {
    tagData,
    contentTagData,
    tagLoading,
    cmsTagLoading,
    fetchAllTagData,
    fetchCmsContentTagData,
    postLinkTag,
  } = useManageContentStore();
  const [options, setOptions] = useState([]);
  const [selectedArray, setSelectedArray] = useState([]);
  const [dropDownOptions, setDropdownOptions] = useState([]);
  const { setToaster } = useToast();

  useEffect(() => {
    fetchAllTagData(contentKey);
    fetchCmsContentTagData(contentKey);
  }, [contentKey]);

  useEffect(() => {
    const mappedTags = tagData?.data?.map((tagData) => {
      return {
        label: tagData.display_name,
        value: tagData.id,
      };
    });
    setOptions(mappedTags);
    setDropdownOptions(mappedTags);
  }, [tagData]);

  useEffect(() => {
    let allLinkedTags = [];
    if (contentTagData && contentTagData.data) {
      allLinkedTags = [...contentTagData.data];
      const arrTag = allLinkedTags
        ?.filter((tag) => tag && tag.id)
        ?.map((tag) => tag.id);

      setSelectedArray(arrTag);
    } else {
      setSelectedArray([]);
    }
  }, [contentTagData]);

  const handleSelect = (value) => {
    setSelectedArray(value);
  };

  const onSearchLinkTag = (val) => {
    const searchData = options.filter((row) =>
      row.label?.toLowerCase().includes(val.toLowerCase().trim())
    );
    setDropdownOptions(searchData);
    if (val.trim() === "") {
      setDropdownOptions(options);
    }
  };

  const handleSave = () => {
    postLinkTag(
      {
        tagIds: selectedArray,
        contentId: contentKey,
      },
      setToaster,
      setModalShow
    );
  };

  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Link Tags
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body
          className="scrollable-container"
          style={{ maxHeight: "82vh", overflowY: "scroll" }}
        >
          <div>
            <Select
              mode="multiple"
              placeholder="Please select"
              style={{ width: "100%" }}
              options={dropDownOptions}
              value={selectedArray}
              onChange={handleSelect}
              onSearch={onSearchLinkTag}
              filterOption={false}
            />
            <div className="d-flex justify-content-end gap-5 mt-4">
              <Button className="btn btn-primary" onClick={handleSave}>
                Save
              </Button>
              <Button
                className="btn btn-secondary"
                onClick={() => setModalShow(false)}
              >
                cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ManageContentLinkModal;
